{
  "agendasAndModules": {
    "conditions": {
      "list": "Zoznam podmienok",
      "filters": {
        "title": "Filtrovať podľa položky formulára",
        "actions": "Akcie"
      },
      "confirmationDeletionModal": {
        "title": "Naozaj chcete odstrániť rest api šablónu?",
        "text": "Potvrdením sa odstráni rest api šablóna."
      }
    },
    "numberOfSelectedValues": "Počet vybraných hodnôt"
  },
  "modulesAndAgendas": {
    "numberFormatting": {
      "unit": "Jednotka",
      "separator": {
        "label": "Oddeľovač tisícov",
        "none": "Žiadny",
        "space": "Medzera",
        "dot": "Bodka",
        "comma": "Čiarka"
      },
      "mathRound": {
        "label": "Matematické zaokrúhlenie",
        "arithmetic": "Aritmetické",
        "up": "Nahor",
        "down": "Nadol"
      },
      "roundTo": {
        "label": "Zaokrúhliť na",
        "tenthousandths": "Zaokrúhlenie na najbližšie desaťtisíciny",
        "thousandths": "Zaokrúhlenie na najbližšie tisíciny",
        "hundredths": "Zaokrúhlenie na najbližšie stotiny",
        "tenths": "Zaokrúhlenie na najbližšie desatiny",
        "dozens": "Zaokrúhlenie na najbližšie desiatky",
        "hundreds": "Zaokrúhlenie na najbližšie stovky",
        "thousands": "Zaokrúhlenie na najbližšie tisícky"
      }
    },
    "sendDataToErp": {
      "modal": "Spárované stĺpce",
      "pairingModal": "Spárované stĺpce"
    },
    "sendDataToErpWithItems": {
      "headerPairing": "Mapovanie polí hlavičky",
      "recordsFormItem": "FormItem typ Záznamy (položky)",
      "itemsTemplate": "Helios šablóna položiek",
      "itemsAgenda": "Agenda položiek",
      "itemsPairing": "Mapovanie polí položiek"
    },
    "takeDataFromErp": {
      "modal": "Spárované stĺpce",
      "pairingModal": "Spárované stĺpce"
    },
    "goToExternalCatalogue": {
      "sendingValuesPairing": "Spárovanie pre odoslanie",
      "receivingRecordsPairing": "Záznamy pre prijatie",
      "receivingValuesPairing": "Spárovanie pre prijatie",
      "shoppingCartHeader": "Hlavička nákupného košíka",
      "shoppingCartItems": "Položky nákupného košíka",
      "additionalPairing": "Doplnenie pri položkách košíka",
      "additionalPairingRowTitle": "Namapovať pole",
      "additionalPairingTarget": "Položka z košíka",
      "additionalPairingSource": "Zdroj"
    },
    "purchaseExternalCatalogue": {
      "sendHeaderPairing": "Spárovanie hlavičky pre odoslanie",
      "sendItemsPairing": "Spárovanie položiek pre odoslanie",
      "receiveHeaderPairing": "Spárovanie hlavičky pre prijatie",
      "receiveItemsPairing": "Spárovanie položiek pre prijatie"
    },
    "buttonAdminTemplate": "Šablóna Admin",
    "actions": {
      "moveAction": "Presunúť akciu",
      "addRow": "Pridať záznam",
      "addRecipient": "Pridať príjemcu",
      "addressees": "Príjemcovia",
      "append": "Pripojiť",
      "createRow": "Nový záznam",
      "delete": "Vymazať",
      "directValue": "Priama hodnota",
      "changeStrategy": "Spôsob úpravy",
      "notificationSetup": "Nastavenie notifikácie",
      "replace": "Nahradiť",
      "requiredAction": "Požadovaná akcia notifikácie",
      "selectedValue": "Vybraná hodnota",
      "target": "Cieľ",
      "source": "Zdroj",
      "selectTablesColumn": "Vybrať stĺpec tabuľky",
      "selectRecordsColumn": "Vybrať stĺpec odkazovaného záznamu",
      "selectUsersColumn": "Vybrať atribút používateľa",
      "draft": "Návrh",
      "toSend": "K odoslaniu",
      "isNotEditable": "Nie je editovateľný",
      "mustBeIsKey": "Stĺpec musí byť označený ako kľúč",
      "arrayValuesFormItem": "Pole hodnôt pre dynamický vzťah",

      "step": {
        "executeActionsForChangedRecord": "Spustiť akcie pre zmenený záznam",
        "executeActionsForCreatedRecord": "Spustiť akcie pre vytvorený záznam",
        "1": {
          "_": "Výber iného záznamu",
          "chooseFromForm": "Vybrať prvok z formulára",
          "chooseFromTemplate": "Vybrať stĺpec zo šablóny",
          "catalogueValue": "Hodnota v katalogu",
          "modules": "Moduly",
          "agendas": "Agendy",
          "views": "Pohľady",
          "modalTitle": "Odkaz na iný záznam",
          "noItems": "Žiadne položky",
          "apiTable": "Číselník API",
          "redirectToLastCreatedRecord": "Presmerovať na posledne vytvorený záznam"
        },
        "2": {
          "selectFilter": "Výber filtra",
          "selectPairing": "Výber párovania",
          "selectTargetAgenda": "Výber cieľovej agendy",
          "selectTargetRecords": "Výber cieľového odkazu na záznam",
          "externalFunction": "Externá funkcia"
        },
        "3": {
          "selectInputs": "Výber vstupov",
          "selectOutputs": "Výber výstupov",
          "selectParameter": "Vybrať parameter"
        },
        "linkToRecord": {
          "modalTitle": "Vyberte hodnotu"
        }
      },
      "unselectedValue": {
        "error": "Musíte vybrať všetky požadované hodnoty"
      },
      "typeMismatch": {
        "error": "Typy sa nezhodujú"
      },
      "requiredItems": {
        "error": "Musíte pridať aspoň jednu položku"
      },
      "arrayValuesFormItemRequired": {
        "error": "Musíte vybrať zdrojové pole pre hodnoty viazaných záznamov"
      }
    },
    "change": {
      "modal": "Hodnoty pre zmenu záznamu"
    },
    "condition": {
      "action": "Akcia",
      "add": "Pridať",
      "applyToAll": "Definovať pre všetky atribúty sekcie",
      "comparison": "Porovnanie",
      "comparisonIsBiggerByTooltip": "Je väčší alebo rovný (zdroj +/- hodnota)",
      "comparisonIsSmallerByTooltip": "Je menší alebo rovný (zdroj +/- hodnota)",
      "comparisonIsBiggerTooltip": "Je väčší ako zdroj alebo hodnota",
      "comparisonIsSmallerTooltip": "Je menší ako zdroj alebo hodnota",
      "currentState": "Aktuálny stav",
      "function": "Funkcia",
      "overwrite": "Prepísať",
      "previousState": "Predchádzajúci stav",
      "repeat": "Opakovať",
      "sectionName": "Názov sekcie",
      "sectionDescription": "Popis sekcie",
      "source": "Zdroj",
      "success": {
        "add": "Podmienka bola úspešne pridaná",
        "deleted": "Podmienka bola úspešne odstránená",
        "reordered": "Poradie bolo úspešne zmenené",
        "stateChanged": "Stav bol úspešne zmenený",
        "updated": "Podmienka bola úspešne upravená"
      },
      "template": "Šablóna",
      "value": "Hodnota",
      "sourceAndValue": "Zdroj a hodnota",
      "sourcePlusMinusValue": "zdroj +/- hodnota",
      "sourceOrValue": "zdroj alebo hodnota",
      "whichValue": "akou hodnotou",
      "addGroup": "Pridať skupinu",
      "addCondition": "Pridať podmienku",
      "addGroupInside": "Pridať skupinu dovnútra",
      "addConditionInside": "Pridať podmienku dovnútra",
      "errors": {
        "conditions": "Musíte vybrať aspoň jednu podmienku",
        "actions": "Musíte vybrať aspoň jednu akciu",
        "missingConditionsError": "Musíte vybrať aspoň jednu podmienku",
        "notCompleteError": "Podmienka nie je kompletná"
      },
      "state": {
        "_": "Stav",
        "logicalOperator": "Logický operátor",
        "editable": "Upraviteľný",
        "hidden": "Skrytý",
        "visible": "Viditeľný"
      }
    },
    "conditionsSection": "Nové podmienky",
    "create": {
      "modal": "Hodnoty pre vytvorenie nového záznamu"
    },
    "CreatedDate": "Dátum vytvorenia",
    "CurrentUser": "Aktuálny používateľ",
    "DateNow": "Dátum a čas",
    "distinctForEach": {
      "modal": "Hodnoty pre vytvorenie nového záznamu"
    },
    "createForEach": {
      "modal": "Hodnoty pre vytvorenie nového záznamu"
    },
    "dialog": {
      "behavior": {
        "label": "Správanie",
        "DiscardAndSave": "Zahodiť a uložiť",
        "KeepAndSave": "Ponechať a uložiť",
        "Keep": "Ponechať"
      },
      "formItems": "Položky formulára"
    },
    "form": {
      "checked": "Zaškrtnuté",
      "clear": "Vyprázdniť sekciu",
      "clearContent": "Naozaj chcete vyprázdniť obsah sekcie?",
      "confirmAction": "Potvrdiť akciu",
      "runAction": "Spustiť",
      "RunActionsWithoutSaving": "Spustiť akciu bez uloženia.",
      "SaveButDoNotRunActions": "Uložiť, ale nespúšťať akcie.",
      "NotifyUserToSave": "Naozaj chcete spustiť túto akciu?",
      "delete": "Vymazať sekciu",
      "deleteItem": "Vymazať položku sekcie",
      "deleteContent": "Naozaj chcete vymazať celú sekciu vrátane všetkých jej položiek? Ak má niektorá položka závislosti, vymazanie sa nevykoná. Tieto väzby je potrebné najprv vyriešiť samostatne.",
      "deleteSectionConflict": "Niektoré položky tejto sekcie sa používajú inde v systéme. Najprv vyriešte ich závislosti pri príslušných položkách a potom skúste sekciu znova vymazať.",
      "deleteItemContent": "Naozaj chcete vymazať položku sekcie?",
      "deleteItemFlow": {
        "blockingDependencies": "Kde sa položka používa",
        "cleanupTitle": "Vymažú sa aj súvisiace nastavenia",
        "blockedTitle": "Túto položku formulára nie je možné vymazať",
        "blockedDescription": "Pred vymazaním položky formulára odstráňte všetky blokujúce závislosti.",
        "cleanupDescription": "Spolu s položkou formulára sa vymažú nižšie uvedené sekcie, pravidlá viditeľnosti a akcie vymazania oznámení. Každá sekcia sa vymaže celá, aj keď položku používa len jedno pravidlo alebo akcia.",
        "deleteWithDependencies": "Vymazať položku aj súvisiace nastavenia",
        "dependencyCount": "Počet závislostí: {{count}}",
        "viewDetails": "Zobraziť podrobnosti",
        "affectedSections": "Sekcie na vymazanie",
        "regularSection": "Sekcia podmienok",
        "recurrentSection": "Sekcia hromadných zmien",
        "globalVisibilityCleanup": "Pravidlá viditeľnosti na vymazanie",
        "deleteNotificationsCleanup": "Akcie vymazania oznámení na vymazanie",
        "deleteNotificationAction": "Akcia {{actionId}}",
        "deleteNotificationOwnerSection": "vlastník sekcie: {{sectionId}}",
        "preflightFailed": "Nepodarilo sa overiť, kde sa položka používa. Pred vymazaním to skúste znova.",
        "dependenciesChanged": "Závislosti sa po otvorení dialógu zmenili. Pred ďalším pokusom skontrolujte obnovené údaje.",
        "deleteFailed": "Položku formulára sa nepodarilo vymazať.",
        "blockers": {
          "OtherAgendaCondition": "Podmienky v ostatných agendách",
          "ForeignFieldVisibility": "Podmienky viditeľnosti ostatných položiek formulára",
          "ViewUsage": "Použitie v zobrazeniach",
          "RecordData": "Vyplnené atribúty záznamov",
          "FormItemDefinition": "Odkazy z definícií iných položiek formulára",
          "FormItemDefaultValue": "Odkazy z predvolených hodnôt položiek formulára"
        }
      },
      "formButtons": "Výber prvkov formulára",
      "globalSettings": "Globálne nastavenia",
      "globalSettingsSuccess": "Globálne nastavenia boli úspešne uložené",
      "item": {
        "dependencies": {
          "label": "Závislosti",
          "conditions": "Podmienky",
          "bulkChanges": "Hromadné zmeny",
          "otherAgendas": "Ostatné agendy",
          "noOtherAgendas": "Žiadne závislosti v ostatných agendách",
          "noVisibilityConditions": "Žiadne podmienky viditeľnosti",
          "loadFailed": "Závislosti sa nepodarilo načítať",
          "module": "Modul",
          "matchingSections": "Zodpovedajúce sekcie: {{count}}",
          "matchedZones": "Zodpovedajúce oblasti",
          "matchedActions": "Zodpovedajúce akcie",
          "states": {
            "active": "Aktívne",
            "disabled": "Zakázané"
          },
          "noSections": "Žiadne zodpovedajúce sekcie",
          "ownerFormItem": "Položka formulára",
          "visibilitySection": "Sekcia viditeľnosti",
          "referencedFormItem": "Odkazuje na vybranú položku formulára",
          "visibilityConditions": "Podmienky viditeľnosti",
          "globalConditions": "Globálne podmienky"
        },
        "columnSettings": {
          "invalidConfiguration": "Skontrolujte nastavenie šírky stĺpcov pri položkách: {{items}}. Pevná šírka musí byť kladné celé číslo a relatívna šírka musí byť vybraná.",
          "title": "Šírka stĺpca v tabuľkovom zobrazení",
          "widthMode": "Šírka stĺpca",
          "modes": {
            "auto": "Automatická",
            "fixed": "Pevná hodnota",
            "relative": "Širší/Užší"
          },
          "fixedWidth": "Šírka",
          "positiveInteger": "Zadajte kladné celé číslo.",
          "preset": "Prednastavená šírka",
          "presets": {
            "normal": "Normálna",
            "wider": "Širšia",
            "widest": "Najširšia"
          },
          "overflow": "Pretečenie obsahu",
          "overflowModes": {
            "ellipsis": "Tri bodky + pomôcka",
            "wrap": "Zalamovať"
          },
          "preview": "Náhľad",
          "previewText": "Ukážka dlhšieho obsahu bunky tabuľky",
          "help": "Nastavte, ako sa toto pole zobrazí ako stĺpec v tabuľke.",
          "modeHelp": {
            "auto": "Šírku stĺpca určí tabuľka automaticky.",
            "fixed": "Nastavte presnú šírku stĺpca v pixeloch.",
            "relative": "Vyberte jednu z troch prednastavených šírok stĺpca."
          },
          "fixedHelp": "Pixely (px). Zadajte celé číslo väčšie ako 0.",
          "invalidWidth": "Zadajte platnú šírku",
          "overflowHelp": {
            "ellipsis": "Text zostane na jednom riadku. Celú hodnotu zobrazíte prejdením myšou alebo zameraním bunky klávesnicou.",
            "wrap": "Celá hodnota sa zobrazí na viacerých riadkoch. Výška riadka sa prispôsobí textu."
          },
          "previewColumn": "Hodnota poľa",
          "previewHelp": "Ilustračný náhľad. Veľké šírky sú tu obmedzené dostupným miestom."
        },
        "columnSelection": "Výber stĺpca",
        "multiColumnSelection": "Výber viacerých stĺpcov",
        "columnToShow": "Stĺpec na zobrazenie",
        "collapse": "Načítať sekciu ako zbalenú",
        "view": "Zobrazenie",
        "viewMode": {
          "label": "Zobrazovací režim",
          "dialog": "Dialog",
          "nestedListing": "Položkový prehľad",
          "portal": "Portál"
        },
        "button": {
          "label": "Meno tlačidla",
          "placeholder": "Pomenujte tlačidlo",
          "showButtonDirectly": "Zobraziť priamo na riadku"
        },
        "comment": {
          "add": "Pridať komentár",
          "edit": "Upraviť komentár",
          "text": "komentáre"
        },
        "computed": {
          "_": "Dopočítaný text",
          "add": "Pridať dalšie",
          "operation": "Operácia",
          "operationType": {
            "add": "Súčet",
            "average": "Priemer",
            "chain": "Spojenie",
            "divide": "Delenie",
            "max": "Maximum",
            "min": "Minimum",
            "multiply": "Násobenie",
            "subtract": "Rozdiel"
          },
          "prefix": "Pole pre vyplnenie",
          "value": "Vybrať hodnotu",
          "referencedFormItemId": "Stĺpec pre operáciu",
          "errors": {
            "empty": "Musíte vybrať hodnotu",
            "noJoinTypes": "Chyba: Nie je možné načítať typy operácií"
          }
        },
        "date": {
          "from": "Vybrať hodnotu od",
          "settings": "Nastavenie prvku",
          "to": "Vybrať hodnotu do",
          "value": "Hodnota"
        },
        "fileUpload": {
          "add": "Nahrať dokument",
          "text": "Kliknutím vyberte dokument alebo ho sem potiahnite"
        },
        "placeholder": {
          "one": "Presuňte požadované elementy pre vytvorenie formulára.",
          "two": "Tlačítkom + pridávate ďalšiu kolonku."
        },
        "records": {
          "_": "Odkaz na iný záznam",
          "external": "Odkaz na externý záznam",
          "interactionOptions": {
            "label": "Možnosti interakcie",
            "creation": "Vytváranie nových záznamov",
            "editing": "Úprava existujúcich záznamov",
            "addition": "Pridávanie existujúcich záznamov"
          },
          "nestedListing": {
            "addRowError": "Chyba pri ukladaní záznamov",
            "addRowSuccess": "Uložené",
            "deletion": "Vymazať záznamy",
            "deleteSuccess": "Záznamy boli úspešne vymazané",
            "deleteError": "Chýba pri mazaní záznamov"
          },
          "updateRowsSuccess": "Upravené",
          "updateRowsError": "Chyba pri úprave záznamov",
          "calculate": {
            "fieldRequired": "Toto pole je povinné pre výpočet",
            "fillAllRequiredFields": "Prosím vyplňte všetky povinné polia pred výpočtom"
          },
          "editableWithRecordDetail": "Editovať súčasne s detailom"
        },
        "tables": {
          "_": "Výber z tabuliek",
          "title": "Tabulky"
        },
        "user": {
          "_": "Výber užívateľa",
          "roleSelect": "Výber role",
          "userSettingsSelect": "Výber užívateľského nastavenia"
        },
        "editSection": "Upraviť sekciu",
        "newSection": "Nová sekcia",
        "record": {
          "directValue": "Hodnota",
          "paramsFilledError": "Musíte vyplniť všetky parametre"
        },
        "recordExternal": {
          "flowItem": "Výber prvku flow z formulára",
          "heliosItem": "Výber prvku z helios šablóny"
        },
        "renameSection": "Premenovať sekciu"
      },
      "saveSuccess": "Údaje boli úspešne uložené",
      "table": {
        "title": "Nastavenie tabuľky"
      },
      "warning": {
        "addInVisibility": "Aplikovanie nastavenia sa pridá ku všetkým existujúcim nastaveniam na jednotlivých prvkoch v rámci sekcie.",
        "emptySection": "V sekcii nie sú nastavené žiadne prvky",
        "changeInVisibility": "Aplikovanie nastavenia nahradí všetky existujúce nastavenia na jednotlivých prvkoch v ramci sekcie.",
        "sectionNameExists": "Tento názov sekcie už existuje",
        "moveSubTabLayoutChange": "Cieľová sekcia má menej stĺpcov alebo riadkov. Rozloženie všetkých záložiek podsekcií v tejto sekcii sa zmení. Chcete pokračovať?"
      }
    },
    "formSection": {
      "hasActionInputs": "Atribúty editovateľné v detaile",
      "conditions": "Podmienky",
      "columnBorderColor": "Zafarbenie orámovania atribútu",
      "attributeColor": "Zafarbenie pozadia atribútu",
      "attributeTextColor": "Farba písma atribútu",
      "iconColor": "Farba ikony",
      "textStyleBold": "Tučné písmo",
      "textStyleItalic": "Kurzíva",
      "textStyleUnderlined": "Podčiarknuté písmo",
      "labelLayout": "Rozloženie štítku",
      "labelLayoutSideBySide": "Vedľa seba",
      "labelLayoutStacked": "Pod sebou",
      "labelAlign": "Zarovnanie štítku",
      "valueAlign": "Zarovnanie hodnoty",
      "align": {
        "left": "Vľavo",
        "center": "Na stred",
        "right": "Vpravo"
      },
      "enableConditions": "Povoliť podmienky"
    },
    "importAgenda": {
      "_": "Importovať agendu",
      "exported": "Exportovaná agenda",
      "newVersion": "Importovať novú verziu agendy",
      "invalidJSON": "Neplatný formát JSON súboru",
      "emptySelectError": "Musia byť vybrané obidve položky"
    },
    "linkToDifferentRecordStepModal": "Odkaz na iný záznam",
    "maxFilesNumber": "Maximálny počet súborov",
    "MobileAccess": "Mobilný prístup",
    "new": "Nová agenda",
    "rolesSection": "Role",
    "SelectAllFromView": "Vybrať všetko",
    "settingsSection": "Údaje pre agendu",
    "UpdatedDate": "Dátum aktualizácie",
    "UserEmail": "Email používateľa",
    "UserContactEmail": "Kontaktný email používateľa",
    "UserReference": "Referencia",
    "UserId": "ID používateľa",
    "RealUserId": "ID skutočného používateľa",
    "UserRole": "Rola používateľa",
    "noticeOnSaving": {
      "title": "Upozornenie pri ukladaní",
      "none": "Žiadne upozornenie",
      "pointOut": "Len upozorniť",
      "forcedSave": "Vynútené uloženie",
      "calculate": "Prepočítať hodnoty",
      "runActionsWithoutSaving": "Spustiť akcie bez uloženia",
      "saveButDoNotRunActions": "Uložiť, ale nespúšťať akcie"
    },
    "confirmationModalBeforeNavigation": {
      "title": "Naozaj chcete opustiť túto stránku?",
      "description": "Potvrdením budú všetky neuložené zmeny uložené."
    },
    "settings": {
      "hideInOverviews": "Skryť v prehľadoch agend",
      "status": "Stav",
      "statusSelect": "Vyberte stav",
      "statuses": {
        "active": "Aktívne",
        "draft": "Návrh",
        "archived": "Archivované"
      }
    },
    "EmptyValue": "Prázdná hodnota",
    "RecordId": "ID záznamu",
    "ParentRecordId": "ID rodičovského záznamu",
    "records": {
      "of": "z",
      "records": "záznamov"
    },
    "None": "Žiadny",
    "Body": "Telo",
    "Header": "Hlavička",
    "Status": "Stav",
    "Error": "Chyba"
  },
  "tables": {
    "deleteConfirmation": "Naozaj chcete zmazať vybrané tabuľky? Táto akcia je nevratná.",
    "deleteViewConfirmation": "Naozaj chcete zmazať vybrané pohľady? Táto akcia je nevratná.",
    "modalAddtable": {
      "addColumn": "Pridať stĺpec",
      "columnName": "Názov stĺpca",
      "editColumn": "Upraviť stĺpec",
      "error": {
        "missingColumns": "Tabuľka musí obsahovať aspoň jeden stĺpec",
        "uniqueName": "Názov tabuľky musí byť unikátny",
        "uniqueRequired": "Aspoň jeden stĺpec musí byť označený ako jedinečný",
        "invalidColumnType": "Tabuľka obsahuje nesprávny typ stĺpca",
        "invalidMappingKey": "Tabuľka obsahuje neplatné mapovanie REST API stĺpca"
      },
      "tableName": "Názov tabuľky",
      "sourceType": "Typ zdroja",
      "sourceTypeModal": {
        "title": "Vyberte typ zdroja",
        "sort": {
          "label": "Zoradenie typov zdrojov",
          "asc": "Od A po Z",
          "desc": "Od Z po A"
        }
      },
      "tableNamePlaceholder": "Zadajte názov tabuľky",
      "title": {
        "_": "Pridať tabuľku",
        "create": "Pridať tabuľku",
        "edit": "Upraviť tabuľku"
      },
      "unique": "Stĺpec je unikátní"
    },
    "successfully": {
      "created": "Tabulky boli úspešne vytvorené",
      "deleted": "Tabulky boli úspešne zmazané",
      "updated": "Tabulky boli úspešne upravené"
    }
  },
  "actions": {
    "actionsTypes": {
      "Archive": "Archivovať",
      "Change": "Zmeniť",
      "Create": "Vytvoriť",
      "Dialog": "Dialógové okno",
      "Delete": "Vymazať",
      "DeleteNotification": "Vymazať oznámenie",
      "IncreaseVersion": "Zvýšiť verziu",
      "Notify": "Oznámiť",
      "DistinctForeach": "Jedinečný pre všetkých",
      "CreateForEach": "Vytvoriť pre všetkých",
      "SendDataToErp": "Odoslať dáta do ERP",
      "TakeDataFromErp": "Načítať dáta z ERP",
      "GoToExternalCatalogue": "Presmerovať na EK",
      "PurchaseExternalCatalogue": "Odoslať objednávku do EK",
      "SendDataToErpWithItems": "Odoslať dáta do ERP s položkami",
      "ExternalAction": "Externá akcia",
      "ExternalRestApi": "Externé Rest Api",
      "Redirect": "Presmerovať",
      "Halt": "Zastaviť"
    },
    "notificationValue": "Hodnota notifikácie"
  },
  "agendas": {
    "modules": {
      "select": "Vyberte modul"
    }
  },
  "importAgendas": {
    "deleteConfirmation": "Naozaj chcete zmazať vybrané importy? Táto akcia je nevratná."
  },
  "massChange": {
    "launch": "Spustiť",
    "succesfullyExecuted": "Úspešne spustené"
  },
  "notificationTemplates": {
    "form": {
      "addParameter": "Pridať parameter",
      "email": "Email notifikácie",
      "insertParam": "Vložiť parameter",
      "name": "Názov notifikácie",
      "fallbackAdmins": "Správca notifikácie",
      "fallbackAdminsTooltip": "Spravuje notifikácie a dostáva notifikácie o tom, ktorému neaktívnemu používateľovi boli neúspešne odoslané notifikácie – tieto notifikácie sú preposielané Správcovi notifikácie",
      "fallbackAdminsEmpty": "Žiadni dostupní správcovia",
      "fallbackAdminsError": "Nepodarilo sa načítať správcov",
      "inactiveUser": "Neaktívny používateľ",
      "nameRequired": "Názov notifikácie je povinné",
      "parameter": "Názov parametra",
      "parameterExists": "Tento parameter už existuje",
      "parameterRequired": "Vyžaduje sa názov parametra",
      "push": "Push notifikácie",
      "subject": "Predmet",
      "subjectRequired": "Predmet je povinný",
      "text": "Text notifikácie",
      "web": "Notifikácia v aplikácii",
      "description": "Popis",
      "bodyRequired": "Text notifikácie je povinný",
      "notificationRequired": "Musíte vybrať aspoň jeden typ notifikácie",
      "channels": "Kanály"
    },
    "confirmationModalForLeaving": {
      "title": "Naozaj chcete opustiť túto stránku?",
      "description": "Kliknutím na potvrdenie opustíte stránku a stratíte neuložené dáta."
    },
    "confirmationModalForRemoving": {
      "title": "Naozaj si prajete odstrániť túto notifikačnú šablónu?",
      "description": "Kliknutím na potvrdenie bude šablóna odstránená."
    },
    "title": {
      "listOfTemplates": "Notifikačné šablóny",
      "detailTitle": "Notifikačná šablóna",
      "usedByTemplates": "Použité v Helios šablónach"
    }
  },
  "recurrence": {
    "label": "Opakovanie",
    "daily": "Denne",
    "hourly": "Každú hodinu",
    "monthly": "Mesačne",
    "never": "Nikdy",
    "weekly": "Týždenne",
    "yearly": "Ročne"
  },
  "recurrenceType": {
    "label": "Typ opakovania",
    "patternonly": "Iba vzor",
    "timeranged": "Time Ranged",
    "timespecific": "Time Specific"
  },
  "executeFrom": "Vykonať od",
  "executeTill": "Vykonať do",

  "restApiConnections": {
    "action": {
      "arrayBehavior": {
        "label": "Typ transformácie poľa",
        "TakeFirst": "Zobrať prvý",
        "TakeLast": "Zobrať posledný",
        "JoinAll": "Spojiť všetky",
        "UseAll": "Použiť všetky",
        "FollowLink": "Nasledovať odkaz",
        "DirectContent": "Priame stiahnutie"
      },
      "inputs": {
        "headers": "Hlavičky volania",
        "label": "Rest Api volanie",
        "parameters": "Parametre volania",
        "parameterName": "Názov parametra"
      },
      "arrayJsonPath": "JSON cesta poľa",
      "outputs": {
        "fileName": "Názov súboru (nepovinné)",
        "isKey": "Je kľúč",
        "label": "Transformácia výstupu"
      },
      "migrationWarning": "Táto šablóna bola vytvorená pred zavedením pripojení. Pre pokračovanie prosím znova vyberte pripojenie.",
      "transformationType": {
        "label": "Typ transformácie hodnoty",
        "None": "Žiadna",
        "Text": "Text",
        "Number": "Číslo",
        "Bool": "Logická hodnota",
        "Date": "Dátum"
      }
    },
    "form": {
      "authType": "Typ autentifikácie",
      "authTypes": {
        "None": "Žiadna",
        "BasicAuth": "Basic auth",
        "TokenAuth": "Token auth",
        "ApiKey": "API kľúč",
        "OAuth2": "OAuth 2.0"
      },
      "baseUrl": "Base url",
      "basicAuthUsername": "Používateľské meno pre basic auth",
      "basicAuthPassword": "Heslo pre basic auth",
      "basicAuthPasswordPlaceholder": "Nechajte prázdne, aby sa zachovalo existujúce",
      "tokenAuthLoginRequest": "Prihlasovacia požiadavka",
      "tokenAuthRefreshRequest": "Obnovovacia požiadavka",
      "tokenAuthTokenExtraction": "Extrakcia tokenu",
      "tokenAuthUsername": "Používateľské meno pre token auth",
      "tokenAuthPassword": "Heslo pre token auth",
      "tokenAuthPasswordPlaceholder": "Nechajte prázdne, aby sa zachovalo existujúce",
      "tokenAuthLoginHttpMethod": "HTTP metóda prihlásenia",
      "tokenAuthLoginRelativeUri": "Relatívne URI prihlásenia",
      "tokenAuthLoginBodyTemplate": "Šablóna tela prihlásenia",
      "tokenAuthRefreshHttpMethod": "HTTP metóda obnovenia",
      "tokenAuthRefreshRelativeUri": "Relatívne URI obnovenia",
      "tokenAuthRefreshBodyTemplate": "Šablóna tela obnovenia",
      "tokenAuthTokenPath": "Cesta k tokenu",
      "tokenAuthRefreshTokenPath": "Cesta k obnovovaciemu tokenu",
      "tokenAuthTokenTtlMinutes": "TTL tokenu (minúty)",
      "tokenAuthRefreshTokenTtlMinutes": "TTL obnovovacieho tokenu (minúty)",
      "name": "Názov pripojenia",
      "title": "Rest api pripojenie"
    },
    "list": "Zoznam rest api pripojení",
    "remove": {
      "title": "Naozaj chcete odstrániť rest api pripojenie?",
      "text": "Potvrdením bude rest api pripojenie odstránené."
    },
    "test": {
      "warning": {
        "title": "Bola vykonaná zmena vo formulári",
        "description": "Formulár obsahuje hodnoty, ktoré nie sú uložené. Pred spustením testu je nutné formulár uložiť."
      }
    },
    "template": {
      "list": "Zoznam šablón rest api",
      "remove": {
        "title": "Do you really want to delete the rest api template?",
        "text": "By confirming, the rest api template will be deleted."
      },
      "form": {
        "body": "Telo požiadavky",
        "headers": {
          "add": "Pridať hlavičku",
          "name": "Názov",
          "value": "Hodnota"
        },
        "httpMethod": "Metódy HTTP požiadavky",
        "logLevel": "Úroveň logovania",
        "name": "Názov rest api",
        "parameterUsageError": "Každý definovaný parameter musí byť použitý (napr. $parameter) v Relative URI, Body alebo v hodnote hlavičky.",
        "relativeUri": "Relatívna uri",
        "title": "Šablóna rest api"
      },
      "test": {
        "label": "Test",
        "response": "Odpoveď",
        "run": "Spustiť test"
      }
    }
  },
  "roles": {
    "approvalPermission": "Schvaľovanie",
    "archivePermission": "Archivácia",
    "commentPermission": "Komentovanie",
    "createPermission": "Tvorba záznamu",
    "deletePermission": "Mazanie",
    "readPermission": "Čítanie",
    "title": "Flow"
  },
  "rows": {
    "deleteConfirmation": "Naozaj chcete zmazať vybrané riadky? Táto akcia je nevratná.",
    "successfully": {
      "added": "Riadky boli úspešne pridané",
      "deleted": "Riadky boli úspešne odstránené",
      "updated": "Riadky boli úspešne upravené"
    }
  },
  "export": {
    "error": "Niečo sa pokazilo.",
    "sentSuccessfully": "Požiadavka na export odoslaný. Odkaz na vygenerovaný súbor príde notifikáciou.",
    "toPdf": "Exportovať do PDF",
    "toCsv": "Exportovať do CSV",
    "toZipWithAttachments": "Exportovať s prílohami",
    "toZipWithAttachmentsAndItems": "Exportovať s prílohami a položkami",
    "allToCsv": "Exportovať všetko do CSV",
    "toXlsx": "Exportovať do Excelu",
    "title": "Exportovať"
  },
  "view": {
    "sortBy": "Zoradiť podľa",
    "desc": "zostupne",
    "typeSelect": "Typ pohľadu",
    "actionForm": "Formulárový pohľad",
    "standard": "Štandardný pohľad",
    "calendar": "Kalendárový pohľad",
    "calendarSettings": {
      "formItems": {
        "allDay": "Celodenná udalosť",
        "category": "Kategória",
        "endDate": "Dátum ukončenia",
        "startDate": "Dátum začiatku",
        "title": "Názov"
      },
      "label": "Nastavenia kalendára"
    },
    "catalogue": "Katalógový pohľad",
    "userSettings": "Osobné nastavenia užívateľa",
    "shoppingCart": "Nákupný košík",
    "shoppingCartSettings": "Nastavenia nákupného košíka",
    "cartDescription": "Popis košíka",
    "cartItems": "Počet položiek v košíku",
    "cartTotal": "Celková cena",
    "cartUser": "Používateľ košíka (Filter aktuálneho používateľa)",
    "submitFormItems": "Položky formulára pre odoslanie",
    "emptyCart": "Váš košík je prázdny",
    "items": "položiek",
    "errors": {
      "submitFormItemsRequired": "Pre nákupné košíky je potrebná aspoň jedna položka formulára pre odoslanie"
    },
    "showNestedListColumns": "Zobraziť stĺpce vnoreného zoznamu",
    "doNotDisplay": "Nezobrazovať",
    "displayInFilter": "Zobraziť pri filtrovaní",
    "displayAlways": "Zobraziť vždy",
    "displayInParentWhenFiltering": "Zobraziť v pohľade nadradenej agendy",
    "showOnlyExistingValues": "Zobraziť len existujúce hodnoty vo filtri",
    "showInToolbar": "Zobraziť v paneli nástrojov"
  },
  "conditionLogs": {
    "search": "Hľadať logy",
    "subtab": {
      "forEach": "Hromadné akcie",
      "erp": "ERP akcie"
    },
    "filter": {
      "status": "Status",
      "success": "Úspech",
      "failed": "Zlyhanie",
      "recordId": "ID záznamu",
      "forEachRecordId": "ID forEach záznamu",
      "conditionActionId": "ID podmienkovej akcie",
      "conditionSectionId": "ID podmienkovej sekcie",
      "dateFrom": "Dátum od",
      "dateTo": "Dátum do"
    },
    "table": {
      "conditionSectionName": "Názov sekcie podmienky",
      "actionType": "Typ akcie",
      "started": "Zahájené",
      "finished": "Dokončené",
      "isSuccess": "Status",
      "message": "Správa"
    }
  },
  "conditionErpLogs": {
    "tab": "ERP Logy",
    "search": "Hľadať ERP logy",
    "filter": {
      "wasCreated": "ERP akcia",
      "created": "Vytvorené",
      "updated": "Aktualizované",
      "templateId": "ID šablóny",
      "recordId": "ID záznamu",
      "conditionSectionId": "ID podmienkovej sekcie",
      "conditionActionId": "ID podmienkovej akcie",
      "moduleId": "ID modulu",
      "dateFrom": "Dátum od",
      "dateTo": "Dátum do"
    },
    "table": {
      "templateId": "ID šablóny ERP",
      "erpKey": "ID záznamu ERP",
      "wasCreated": "Akcia"
    }
  },
  "warning": {
    "multipleUiDefinitions": "Podmienky pre zobrazenie prvkov sa prekrývajú.",
    "multipleUiDefinitionsWithNames": "Podmienky pre zobrazenie prvkov sa prekrývajú.\n\nPrvky s prekrývajúcimi sa podmienkami:\n"
  }
}
